<template>
  <base-input :model-value="props.email" class="w-100 me-2" label="メールアドレス" placeholder="半角英数字" autocomplete="one-time-code"
              :rules="[rules.requiredWithLabelName({name: 'メールアドレス'}), rules.email]" required-tag
              @update:model-value="emit('update:email', $event)"/>
</template>
<script setup lang="ts">
import {useValidator} from "@/composable/ui/useValidator";
import BaseInput from "@/components/Forms/BaseInput.vue";
import {defineEmits} from "vue";

const props = defineProps({
  email: {
    type: String,
    required: true
  },
});

const emit = defineEmits(['update:email']);
const {rules} = useValidator();

</script>
<style scoped>


</style>
